import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionQuery } from '@app/core/state/session';
import { RightsConst } from '@pezi/entities';

@Directive({
  selector:   '[appHasRightId]',
  standalone: true
})
export class HasRightDirective implements OnInit {
  @Input()
  appHasRightId: RightsConst | RightsConst[];

  constructor(
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private sessionQuery: SessionQuery
  ) {}

  ngOnInit() {
    this.vcr.clear();
    const usr = this.sessionQuery.getLoggedInUser();
    let showContent = false;
    if (!this.appHasRightId) {
      showContent = true;
    } else {
      if (Array.isArray(this.appHasRightId)) {
        if (this.appHasRightId.length === 0) {
          showContent = true;
        } else {
          showContent = (usr.rights && this.appHasRightId.every(right =>
            usr.rights.findIndex(userRight => userRight.rightId === right) !== -1
          ));
        }
      } else {
        showContent = (usr.rights && usr.rights.findIndex(right => right.rightId === this.appHasRightId) !== -1);
      }
    }
    if (showContent) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }

}
